import {
  Box,
  Divider
} from '@mui/material'

import { useContext, useEffect } from 'react'

// Components
import CarryCapacity from 'src/components/common/CarryCapacity'
import Stats from 'src/components/Stats'

// Context
import { InventoryDataContext } from 'src/store/inventory/Store'
import { setEquippedStats } from 'src/store/stats/actions'
import { ItemDataContext } from 'src/store/items/Store'
import { StatsDispatchContext } from 'src/store/stats/Store'
import Inventory from './Inventory'
import Info from './Info'
import { NavigationDataContext, NavigationDispatchContext } from 'src/store/navigation/Store'
import { setSwitch } from 'src/store/navigation/actions'

const container = {
  zIndex: 4,
  position: 'absolute',
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: '100vh',
  top: '48px',
  padding: '24px',
  color: 'white',
  backgroundColor: 'black'
}

const Menu = () => {
  const { items } = useContext(ItemDataContext)
  const { navigation } = useContext(NavigationDataContext)
  const { dispatchNavigation } = useContext(NavigationDispatchContext)
  const { dispatchStats } = useContext(StatsDispatchContext)
  const { inventory } = useContext(InventoryDataContext)

  useEffect(() => {
    setEquippedStats(dispatchStats, items, inventory)
  }, [inventory.equipped])

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      setSwitch(dispatchNavigation, 'stats_open', false)
    }
  }, [])

  // development build logs
  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Menu mounted') }
    return process.env.REACT_APP_BENCHMARK === 'true' ? () => console.log('Menu unmounted') : () => { }
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Menu rendered') }
  })

  return (
    <Box sx={container} className="menu">
      { navigation.stats_open ? (
        <>
          <Stats/>
          <Divider sx={{ marginY: 2 }} />
        </>
      ) : null }
      { navigation.inventory_open ? (
        <>
          <Inventory/>
          <Divider sx={{ marginY: 2 }} />
        </> 
      ) : null }
      { navigation.info_open ? (
        <Info/>
      ) : null }
      { navigation.stats_open || navigation.inventory_open ? (
        <CarryCapacity/>
      ) : null }
    </Box>
  )
}

export default Menu
